import React from 'react';

const WarningsSection = ({
  currentLocationId,
  currentShift,
  onShowCloseShiftModal
}) => {
  return (
    <>
      {/* Ostrzezenie gdy nie wybrano lokalizacji */}
      {!currentLocationId && (
        <div style={{
          backgroundColor: 'var(--warning-light)',
          color: 'var(--warning)',
          padding: '0.5rem 0.75rem',
          borderRadius: '4px',
          marginBottom: '0.75rem',
          border: '1px solid var(--warning)',
          textAlign: 'center',
          fontSize: '11px',
          fontWeight: '600'
        }}>
          Wybierz lokalizacje w prawym gornym rogu przed utworzeniem paragonu!
        </div>
      )}

      {/* Ostrzezenie o przeterminowanej zmianie */}
      {currentShift?.is_expired && (
        <div style={{
          backgroundColor: 'var(--danger-light)',
          color: 'var(--danger)',
          padding: '0.75rem 1rem',
          borderRadius: '4px',
          marginBottom: '0.75rem',
          border: '2px solid var(--danger)',
          textAlign: 'center',
          fontSize: '12px',
          fontWeight: '600',
          animation: 'pulse 2s infinite'
        }}>
          UWAGA: Zmiana z dnia <strong>{currentShift.data_zmiany}</strong> jest przeterminowana!
          <br />
          <span style={{ fontSize: '11px', fontWeight: '400' }}>
            Musisz ja zamknac przed rozpoczeciem pracy w nowym dniu.
          </span>
          <button
            data-pos-btn="true"
            onClick={onShowCloseShiftModal}
            style={{
              marginLeft: '1rem',
              padding: '6px 12px',
              fontSize: '12px',
              fontWeight: '600',
              cursor: 'pointer',
              backgroundColor: 'var(--danger)',
              color: 'white',
              border: '1px solid var(--danger)',
            }}
          >
            Zamknij zmiane teraz
          </button>
        </div>
      )}
    </>
  );
};

export default React.memo(WarningsSection);
